import styled from '@emotion/styled';

import { ButtonBase } from 'components/buttons/ButtonBase';

export const ButtonSecondary = styled(ButtonBase)`
  position: relative;
  padding: 6px 12px;
  border-radius: 5px;
  border: 1px solid ${({ theme }) => theme.colors.secondary};
  background-color: ${({ theme }) => theme.colors.secondary};
  font-family: ${({ theme }) => theme.fonts.default};
  font-size: 14px;
  font-weight: 400;

  &:hover {
    background-color: #ff8700;
    border-color: #ff8700;
  }

  .MuiSvgIcon-root {
    margin-right: 4px;
  }
`;
